import { useSelector } from "react-redux";

/**
 * Checks if the user has the required permissions.
 * */
export const usePermission = () => {
  const permissions = useSelector(state => state.auth.user?.permissions) || [];

  const hasPermission = requiredPermissions => {
    if (Array.isArray(requiredPermissions)) {
      return requiredPermissions.some(permission => permissions.includes(permission));
    } else if (typeof requiredPermissions === "string") {
      return permissions.includes(requiredPermissions);
    } else {
      return false;
    }
  };

  return hasPermission;
};
